module.exports = __webpack_public_path__ + "static/img/son2_active.649b4678.png";